import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import type { AssessmentConfig } from '@shared/types';
import '@shared/laadcheck.css';
import App from './App';

const mountEl = document.getElementById('laadcheck-assessment');
if (mountEl) {
  const config: AssessmentConfig = JSON.parse(
    mountEl.dataset.config ?? '{}'
  );
  createRoot(mountEl).render(
    <StrictMode>
      <App config={config} />
    </StrictMode>
  );
}
